module.exports = {
	"id": "NO",
	"name": "Norway",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.00669,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.00669,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.00669,
			"27": null,
			"28": null,
			"29": 0.00669,
			"30": null,
			"31": 0.04014,
			"32": 0.00669,
			"33": 0.01338,
			"34": 0.02676,
			"35": 0.02007,
			"36": 0.01338,
			"37": 0.02007,
			"38": 0.03345,
			"39": 0.0669,
			"40": 0.02676,
			"41": 0.04014,
			"42": 0.01338,
			"43": 0.05352,
			"44": 0.06021,
			"45": 0.07359,
			"46": 0.18732,
			"47": 0.09366,
			"48": 0.08028,
			"49": 0.95667,
			"50": 0.10704,
			"51": 0.42147,
			"52": 0.66231,
			"53": 25.19454,
			"54": 5.94741,
			"55": 0.0669,
			"56": 0.01338,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.01338,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.00669,
			"31": 0.00669,
			"32": null,
			"33": 0.01338,
			"34": 0.00669,
			"35": 0.00669,
			"36": null,
			"37": 0.04683,
			"38": 0.03345,
			"39": 0.02007,
			"40": 0.02007,
			"41": 0.02007,
			"42": 0.02007,
			"43": 0.04683,
			"44": 0.02676,
			"45": 0.11373,
			"46": 0.05352,
			"47": 0.23415,
			"48": 0.48168,
			"49": 5.6865,
			"50": 0.03345,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.02676
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00669,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.04014,
			"37": 0.03345,
			"38": 0.01338,
			"39": 0.02007,
			"40": 1.01019,
			"41": 0.16725,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": 0.00669,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 2.40171
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.03345,
			"6": 0.00669,
			"7": 0.05352,
			"8": 0.40809,
			"9": 0.42816,
			"10": 2.93691,
			"3.1": null,
			"3.2": null,
			"5.1": 0.08028,
			"6.1": 0.08028,
			"7.1": 0.02676,
			"9.1": 2.38164
		},
		"ios_saf": {
			"8": 0,
			"10": 10.7659555204,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.290130043714,
			"8.1-8.4": 0.536002962115,
			"9.0-9.2": 0.255707835137,
			"9.3": 3.90118363863
		},
		"android": {
			"3": 0,
			"4": 0.0115550645995,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00144438307494,
			"4.1": 0.0416807687339,
			"4.2-4.3": 0.104201921835,
			"4.4": 0.238942228682,
			"4.4.3-4.4.4": 0.241005633075
		},
		"ie": {
			"6": 0.0133971868979,
			"7": null,
			"8": 0.120574682081,
			"9": 0.194259210019,
			"10": 0.200957803468,
			"11": 9.90052111753,
			"5.5": null
		},
		"op_mob": {
			"0": 0.170058435014,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00472384541707
		},
		"edge": {
			"12": 0.08697,
			"13": 0.74928,
			"14": 2.79642
		},
		"ie_mob": {
			"10": 0.0554774647887,
			"11": 0.225872535211
		},
		"bb": {
			"7": 0.0041375,
			"10": null
		},
		"samsung": {
			"0": 3.82636
		},
		"and_uc": {
			"0": 0.05958
		},
		"op_mini": {
			"0": 2.29116771957
		},
		"and_chr": {
			"0": 10.48991
		},
		"and_ff": {
			"0": 0.02317
		}
	},
	"total": 98.9196375
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NO.json
 ** module id = 611
 ** module chunks = 0
 **/